module.exports = __webpack_public_path__ + "assets/afpi-logo.png";